angular.module('memberPortal').controller('MembershipCtrl', ["$scope", "$stateParams", "$filter", "DataService", "membership", function($scope, $stateParams, $filter, DataService, membership) {
  $scope.data = DataService;
  $scope.hash = $stateParams.m;
  $scope.membership = membership;
  return $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
}]);
